module.exports = __webpack_public_path__ + "assets/flags/lv.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/lv.svg
// module id = 507
// module chunks = 0